import httpService from "..";

// Create a notification for a user
export const createUserNotificationApi = async (data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/notification`,
    "post",
    data
  );
};

// Get a single notification by ID
export const getNotificationApi = async (notificationId: number) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/notification/single/${notificationId}`,
    "get"
  );
};

// Get all notifications for the current user
export const getNotificationsApi = async (userId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/notification/${userId}`,
    "get"
  );
};

// Mark a notification as read
export const markNotificationAsReadApi = async (notificationId: number) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/notification/${notificationId}/read`,
    "put"
  );
};

// Mark all notifications as read for a user
export const markAllNotificationsAsReadApi = async (userId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/notification/${userId}/read-all`,
    "put"
  );
};

// Delete a notification
export const deleteNotificationApi = async (notificationId: number) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/notification/${notificationId}`,
    "delete"
  );
};

// Get unread notification count
export const getUnreadCountApi = async (userId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/notification/${userId}/unread-count`,
    "get"
  );
};
